import type { RouteRecordRaw } from 'vue-router'
import { UserRole } from '@/types/router'

export const userTaskRoutes: RouteRecordRaw[] = [
  {
    path: 'task-publish',
    name: 'TaskPublish',
    component: () => import('@/views/userCenter/PublishTask.vue'),
    meta: {
      title: '发布任务',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'EditPen',
      order: 10,
      breadcrumb: true,
      cache: false,
      description: '众包任务发布，支持需求描述、预算设置和条件筛选',
    },
  },
  {
    path: 'published-tasks',
    name: 'PublishedTasks',
    component: () => import('@/views/userCenter/PublishedManagement.vue'),
    meta: {
      title: '发布管理',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'List',
      order: 11,
      breadcrumb: true,
      cache: false,
      description: '已发布任务管理，包含进行中、已完成、已取消的任务',
    },
  },
  {
    path: 'accepted-tasks',
    name: 'AcceptedTasks',
    component: () => import('@/views/userCenter/TaskUndertakingManager.vue'),
    meta: {
      title: '承接管理',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN], // 允许所有用户查看，但功能受权限限制
      permissions: ['user:tasks:view'], // 基础查看权限
      layeredPermissions: {
        view: ['user:tasks:view'], // 页面查看权限
        accept: ['user:tasks:accept'], // 承接任务权限
        manage: ['user:tasks:manage'], // 任务管理权限
      },
      permissionGuidance: {
        missingPermission: 'user:tasks:accept',
        upgradeMessage: '成为认证设计师或制造商即可承接任务获得收益',
      },
      icon: 'Checked',
      order: 12,
      breadcrumb: true,
      cache: false,
      description: '承接任务管理和收益追踪，了解平台任务承接价值',
    },
  },
  {
    path: 'task/:id/manage',
    name: 'TaskConsole',
    component: () => import('@/views/userCenter/tasks/TaskConsole.vue'),
    meta: {
      title: '任务控制台',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Monitor',
      order: 13,
      breadcrumb: true,
      cache: false,
      description: '任务控制台 - 资金管理与选标',
    },
  },
  {
    path: 'task/:taskId/pay-escrow',
    name: 'EscrowPayment',
    component: () => import('@/views/userCenter/EscrowPaymentPage.vue'),
    meta: {
      title: '托管支付',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Lock',
      order: 14,
      breadcrumb: true,
      breadcrumbParent: 'PublishedTasks',
      cache: false,
      description: '支付任务托管资金',
    },
  },
]
